import { Box } from '@drivekyte/ui';

import { useRouter } from 'next/router';
import FooterContent from './components/footer-content';
import FooterTopSection from './components/top-section';

const Footer = () => {
  const router = useRouter();

  if (
    router.pathname === '/checkout' ||
    (router.pathname === '/order-details/[id]' &&
      router.query.returning_user !== 'true')
  ) {
    return null;
  }

  return (
    <Box>
      <FooterTopSection />
      <FooterContent />
    </Box>
  );
};

export default Footer;
